import { getRepository } from '@things-factory/shell'

import { Tutorial } from '../../../entities'

export const tutorialResolver = {
  async tutorial(_: any, { name }, context: ResolverContext) {
    const { domain } = context.state

    return await getRepository(Tutorial).findOne({
      where: { domain: { id: domain.id }, name },
      relations: ['domain', 'creator', 'updater']
    })
  }
}
